import actions from '../../actionTypes';

export default siteUserId => {
  return {
    type: actions.DELETE_SITE_USER,
    siteUserId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/deleteSiteUser.js